module.exports = __webpack_public_path__ + "img/grend_gugge_1.cca3b4c2.jpg";